// Shared validation for branch contact fields (dashboard + modals).
const ARABIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";

export const normalizeDigits = (value = "") =>
  String(value).replace(/[٠-٩]/g, (digit) => String(ARABIC_DIGITS.indexOf(digit)));

export const normalizePhone = (value = "") => normalizeDigits(value).trim();

// Optional leading +, then 7–20 digits / spaces / dashes / parentheses.
export const isValidPhone = (value) => {
  const phone = normalizePhone(value);
  if (!/^\+?[0-9\s\-()]{7,20}$/.test(phone)) return false;
  return phone.replace(/\D/g, "").length >= 7;
};

export const isValidLocationUrl = (value) => {
  try {
    const url = new URL(String(value || "").trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const LICENSE_ACCEPT = "application/pdf,image/jpeg,image/png,image/webp";
export const LICENSE_MAX_BYTES = 10 * 1024 * 1024;
const LICENSE_TYPES = ["application/pdf", "image/jpeg", "image/jpg", "image/png", "image/webp"];

// Returns "type" | "size" | null.
export const licenseFileProblem = (file) => {
  if (!file) return null;
  if (!LICENSE_TYPES.includes(file.type)) return "type";
  if (file.size > LICENSE_MAX_BYTES) return "size";
  return null;
};
